import { Component, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RepresentativeControls } from '../edit-case-dialog.service';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';

export type DialogData = {
  lock_representatives: FormControl<boolean>;
  representatives: FormArray<FormGroup<RepresentativeControls>>;
};

@Component({
  selector: 'app-lock-representatives-dialog',
  templateUrl: './lock-representatives-dialog.component.html',
  styleUrls: ['./lock-representatives-dialog.component.scss'],
  imports: [PayeePopupComponent],
})
export class LockRepresentativesDialogComponent {
  private dialogRef =
    inject<MatDialogRef<LockRepresentativesDialogComponent>>(MatDialogRef);

  data = inject<DialogData>(MAT_DIALOG_DATA);

  readonly submit = () => {
    this.data.lock_representatives.patchValue(true);
    this.data.representatives.enable();
    this.dialogRef.close();
  };

  readonly cancel = () => {
    this.dialogRef.close();
  };
}
